import { createSelector } from 'reselect';
import { getPartnerDashboardState } from 'src/modules/partner-dashboard/selectors/getPartnerDashboardState';
import { assertNotNull } from 'src/utils/assert';

export const getPartnerDashboardData = createSelector([
  getPartnerDashboardState,
], (state) => assertNotNull(
  state.data,
  'Partner Dashboard is not initialized',
  { state },
));
